<cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "BemerkungGrundbuch" | translate }}
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
    <ng-template #tableRows>
      @for (grundstueckBemerkung of listLoader?.items; track grundstueckBemerkung) {
        <tr>
          <td>
            <span [capHistinfo]="grundstueckBemerkung.histInfo">
              {{ grundstueckBemerkung.text }}
            </span>
          </td>
        </tr>
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
